<template>
    <div id="product-diamond">
        <div class="container">
            <loading v-if="isLoading"></loading>
            <div v-if="!isLoading">
                <!--<steps v-if="!isStoreMode"></steps> -->
                <paging-navigator class="top" v-if="!isStoreMode" :links="getNavigationLinks"></paging-navigator>

                <div class="container text-left">
                    <div class="row justify-content-center align-self-center" v-if="currentDiamond && currentDiamond.name">
                        <div class="col-lg-6 col-md-12">
                            <images-catalog
                                    v-if="currentDiamond.Media && currentDiamond.Media.length"
                                    :media="currentDiamond.Media"
                                    :alt="currentDiamond.name"
                                    :isDiamond="true"
                            ></images-catalog>
                        </div>
                        <div class="col-lg-6 col-md-12 mb-5">
                            <product-details :currentProduct="currentDiamond" :currentStore="currentStore"></product-details>
                        </div>
                    </div>
                    <you-might-also-like v-if="suggestions && suggestions.length" :products="suggestions"></you-might-also-like>
                    <schedule-an-appointment v-if="schedule" @closePopup="closeSchedulePopup" :products="[currentDiamond]"></schedule-an-appointment>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import {mapState, mapActions, mapGetters} from 'vuex';

  import Loading from '../../components/Loading.vue';
  import Steps from '../../components/ProgressBar.vue';
  import YouMightAlsoLike from './YouMightAlsoLike.vue';
  import Details from './Details.vue';
  import ImagesCatalog from './ImagesCatalog.vue';
import PagingNavigatorVue from '../../components/PagingNavigator.vue';
import PopupVue from '../wishlist/Popup.vue';

  export default {
    name: 'product-diamond',
    props: ['url', 'diamondUrl','schedule'],
    components: {
      'paging-navigator': PagingNavigatorVue,
      'loading': Loading,
      'steps': Steps,
      'you-might-also-like': YouMightAlsoLike,
      'product-details': Details,
      'images-catalog': ImagesCatalog,
      'schedule-an-appointment': PopupVue,
      
    },
    data() {
      return {
        currentImage: 1,
      }
    },
      watch: {
          diamondUrl () {
              this.getDiamondProduct({diamondId: this.diamondId, router: this.$router});
          },
      },
    computed: {
      ...mapState('willyou', [
        'isLoading',
        'currentDiamond',
        'suggestions',
        'currentStore',
        'storeMode',
      ]),
      ...mapGetters('willyou', [
        'getCurrentMeta',
      ]),
        diamondId () {
          return this.currentDiamond!==null && this.currentDiamond.internal_lot===this.getDiamondId ?  this.currentDiamond.internal_lot : this.getDiamondId ;
        },
        isStoreMode () {
          return this.storeMode;
        },
        getDiamondId () {
          return this.$route.params.diamondUrl.split('-')[0];
        },
        getCurrentDiamond () {
          return this.currentDiamond;
        },
        getNavigationLinks() {
          let stateName = this.currentStore && this.currentStore.state ? this.currentStore.state: null;
          let cityName = this.currentStore && this.currentStore.city ? this.currentStore.city: null;
          let companyName = this.currentStore && this.currentStore.companyName ? this.currentStore.companyName: null;
          let companyUrl = this.currentStore && this.currentStore.companyUrl ? this.currentStore.companyUrl: null;
          let diamondName = this.currentDiamond && this.currentDiamond.name ? this.currentDiamond.name : null;
          return  [
            {name: 'Home', url: '/'},
            {name: 'Store Locator', url: '/jewelry-stores'},
            {name: stateName , url: `/jewelry-stores/${stateName}`},
            {name: cityName , url: `/jewelry-stores/${stateName}/${cityName}`},
            {name: companyName , url: {name: 'home-store', props:{url: companyUrl}}},
            {name: diamondName , url: this.$route.fullPath},
          ];
        }
    },
    methods: {
      ...mapActions('willyou', [
        'setCurrentPage',
        'setCurrentPath',
        'getDiamondProduct',
        'getStoreData',
        'addProductToWishlist',
      ]),
      closeSchedulePopup() {
         this.$router.push({name: 'product-diamond', props:{url: this.url, diamondUrl: this.diamondUrl, schedule:false} })
       }
    },
    mounted() {
      this.getDiamondProduct({diamondId: this.diamondId, router: this.$router});
      !this.isStoreMode && (!this.currentStore || !this.currentStore.url) ? this.getStoreData({url: this.url, router: this.$router}) : null;
    },
    metaInfo() {
      let meta= this.getCurrentMeta;
      let title = `${meta.title} ${this.getCurrentDiamond ? this.getCurrentDiamond.name : ''}` ;
      meta.title = title;
      meta.meta ? meta.meta.find(m => m.name==="description").content =  title: null ;
      meta.meta && this.getCurrentDiamond ? meta.meta.find(m => m.name==="keywords").content =  [this.getCurrentDiamond.name]: null ;
      return meta;
    },
   
   
  }
</script>

<style lang="scss" scoped>
    #product-diamond {
        min-height: 100vh;
        padding-top: 0;
        .top {
          padding-top:120px;
        }
    }
</style>
